import { isPlatformSuperAdmin } from '../utils/isPlatformSuperAdmin.ts';
import { resolveAuthzV2Enabled } from '../config/authz';

/** @returns {import('./types/authz.types').AuthzGrants} */
export function emptyGrants() {
  return {
    features: {},
    objects: {},
    resources: { accounts: [], campaigns: [] },
    record_actions: {},
  };
}

/**
 * @param {object|null|undefined} user
 * @param {import('./types/authz.types').AuthzGrants|null|undefined} grants
 * @returns {import('./types/authz.types').AuthzContext}
 */
export function buildAuthzContext(user, grants) {
  const normalizedGrants = grants || emptyGrants();
  const isFullAccess = Boolean(
    user?.is_superuser || isPlatformSuperAdmin(user)
  );

  return {
    user,
    isFullAccess,
    isAuthzV2Enabled: resolveAuthzV2Enabled(user),
    grants: {
      features: normalizedGrants.features || {},
      objects: normalizedGrants.objects || {},
      resources: normalizedGrants.resources || { accounts: [], campaigns: [] },
      record_actions: normalizedGrants.record_actions || {},
    },
  };
}

/**
 * @param {object|null|undefined} userData
 * @returns {import('./types/authz.types').AuthzGrants}
 */
export function extractGrantsFromUser(userData) {
  const profile = userData?.profile;
  const rbac = profile?.rbac_grants;
  const legacy = profile?.permissions || userData?.permissions || {};
  const generalPerms = {};
  (profile?.general_user_permission || []).forEach((perm) => {
    if (perm?.name) {
      generalPerms[perm.name.toLowerCase()] = Boolean(perm.is_allowed);
    }
  });

  return {
    features: {
      ...generalPerms,
      ...legacy,
      ...(rbac?.features || {}),
    },
    objects: rbac?.objects || {},
    resources: rbac?.resources || { accounts: [], campaigns: [] },
    record_actions: rbac?.record_actions || {},
  };
}
